import { AxiosResponse } from 'axios';

import { getAuthToken } from '../utils/commonHelper';
import { IRoleRequestsResponse, ITableRequestData } from '../types/common';
import { toast } from 'react-toastify';
import axiosInstance from '../utils/AxiosInstance';

const API_URL = `${process.env.REACT_APP_API_URL}/role`; // Replace with your actual API URL


const customHeaders = {
    'content-type': 'application/json',
};

export const createRoleService = async (data: any): Promise<AxiosResponse<IRoleRequestsResponse>> => {
    try {
        const response: any = await axiosInstance.post(API_URL, data, {
            headers: {
                ...customHeaders,
                Authorization: `Bearer ${getAuthToken()}`,
            },
        });
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const getRoleTableService = async ({ limit, page }: ITableRequestData): Promise<AxiosResponse<IRoleRequestsResponse>> => {
    try {
        let url = `${API_URL}`;

        if (limit !== undefined && page !== undefined) url += `?limit=${limit}&page=${page}`;


        const response = await axiosInstance.get(url, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const getRoleByIdService = async ({ id }: { id: string }): Promise<AxiosResponse<IRoleRequestsResponse>> => {
    try {
        let url = `${API_URL}/getByID/${id}`;
        const response = await axiosInstance.get(url, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const updateRoleService = async ({ id, data }: { id: string, data: any }): Promise<AxiosResponse<IRoleRequestsResponse>> => {
    try {
        let url = `${API_URL}/${id}`;
        const response = await axiosInstance.put(url, data, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });
        if (response.status) {
            toast.success('Return Sales Order updated successfully');
        }
        return response;
    } catch (error: any) {
        throw error;
    }
};

export const deleteRoleService = async ({ id }: { id: string }): Promise<AxiosResponse<IRoleRequestsResponse>> => {
    try {
        let url = `${API_URL}/${id}`;
        const response = await axiosInstance.delete(url, {
            headers: {
                ...customHeaders,
                'Authorization': `Bearer ${getAuthToken()}`
            }
        });

        return response;
    } catch (error: any) {
        throw error;
    }
};
